import type { ReactNode } from 'react'

export type NoticeTone = 'error' | 'success' | 'info'

export interface ActivityNotice {
  tone: NoticeTone
  key: string
  /**
   * Server-provided, already-localized message. When present, it replaces the
   * client catalog key so domain validation copy (activities, chat, admin)
   * reaches the user exactly as the backend rendered it for their locale.
   */
  message?: string
}

const TONE_CLASS: Record<NoticeTone, string> = {
  error: 'border-danger/40 bg-[var(--danger-soft)] text-deep',
  success: 'border-teal/30 bg-mint text-deep',
  info: 'border-line bg-paper text-deep',
}

interface FeedbackNoticeProps {
  tone: NoticeTone
  children: ReactNode
  className?: string
}

/** Inline action feedback scoped to the activity detail feature. */
export function FeedbackNotice({
  tone,
  children,
  className,
}: FeedbackNoticeProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
      className={`rounded-md border px-4 py-3 text-sm font-semibold ${TONE_CLASS[tone]} ${className ?? ''}`}
    >
      {children}
    </div>
  )
}
